import IComponent from "components/commons/IComponent";
import "./DetailPanels.scoped.css";
import CellTable from "components/SearchResult/DetailPanels/TableModules/CellTable";
import { dataProcessFunctions } from "./dataProcessFunctions";
import DownloadFromWebAPI from "utils/DownloadFromWebAPI";
import GetArcGISToken from "utils/GetArcGISToken";
import React from "react";

const addUpgradedByField = (dataArray) => {
  return dataArray.map((obj) => {
    const {
      PRESCRIPT,
      NPRESCRIPT,
      TYPE1_2,
      TYPE3,
      IMPROVED_NPRESCRIPT,
      ACT_COMP,
    } = obj; // Destructure to separate PRESCRIPT from the rest
    return {
      "Upgraded by": "", // Add "Upgraded by:" field
      "Prescriptive Design Using GEO Report No. 56": PRESCRIPT,
      "Non-prescriptive Design Including Conventional Design": NPRESCRIPT,
      "Improved by": "", // Add "Improved by:" field
      "Type 1 / Type 2 Prescriptive Measures": TYPE1_2,
      "Type 3 Prescriptive Measures (not up to upgrading standard)": TYPE3,
      "Non-Prescriptive Design including Conventional Design": IMPROVED_NPRESCRIPT,
      "Actual Completion Date": ACT_COMP,
    };
  });
};
class DetailInfo extends IComponent {
  constructor(props) {
    super(props);
    this.state = {
      BackgroundInfo: [
        {
          alias: "Feature Ref. No.",
          field: "FEATURE",
          value: "",
        },
        {
          alias: "GIU Cell Ref.",
          field: "GIU_GRID",
          value: "",
          childObjKey: "RelatedReport",
        },
        {
          alias: "Location",
          field: "LOCATION",
          value: "",
        },
        {
          alias: "Date of Formation",
          field: "YEAR_FORM",
          value: "",
        },
        {
          alias: "Date of Construction/Modification",
          field: "DATE_CON",
          value: "",
        },
        {
          alias: "Map Sheet Reference (1:1000)",
          field: "MAP1000",
          value: "",
          childObjKey: "RelatedReport",
        },
        {
          alias: "Approximate Coordinates",
          field: "COORDINATES",
          value: "",
        },
        {
          alias: "Aerial Photos ~ Photo No. (Year)",
          field: "AREIAL_PHOTO",
          value: "",
          childObjKey: "RelatedReport",
        },
        {
          alias: "Nearest Rainguage Station (Station Number)",
          field: ["RS_LOCATION", "RS_STATION_NUM"],
          value: "",
          childObjKey: "RelatedReport.RaingaugeStation",
        },
        {
          alias: "Data Collected On",
          field: "PREP_DATE",
          value: "",
        },
        {
          alias: "Date of Construction, Subsequent Modification and Demolition",
          field: "DateOfContructions",
          value: "",
          childObjKey: "RelatedReport",
          tableSpec: [
            {
              alias: "Modification",
              field: "FH_MODIFICATION",
              value: [],
            },
            {
              alias: "Before",
              field: "FH_BEFORE_DATE",
              value: [],
            },
            {
              alias: "After",
              field: "FH_AFTER_DATE",
              value: [],
            },
          ],
        },
        {
          alias: "Related Reports/Files or Documents",
          field: "ReportsDocuments",
          value: "",
          childObjKey: "RelatedReport",
          tableSpec: [
            {
              alias: "File/Report",
              field: "RR_TYPE",
              value: [],
            },
            {
              alias: "Ref. No.",
              field: "RR_FILE_REF_NUMBER",
              value: [],
            },
            {
              alias: "PDF",
              field: "URL",
              value: [],
              urlTransform: (value) => {
                if (typeof value === "string" && value.startsWith("http")) {
                  if (![4, 5, 6, 7].includes(GetArcGISToken.user.userGroup))
                    return (
                      <a href={DownloadFromWebAPI(value)} target="_blank">
                        Open
                      </a>
                    );
                  else
                    return (
                      <a
                        href="No Access"
                        onClick={(evt) => {
                          this.props.showDialog({
                            isOpen: true,
                            type: "error",
                            title: "Access Denied",
                            content:
                              "The user has no permission to open this report",
                            onDialogOk: () => {},
                          });
                          evt.preventDefault();
                        }}
                      >
                        Open
                      </a>
                    );
                } else return value;
              },
            },
          ],
        },
        {
          alias: "Remarks",
          field: "REMARKS",
          value: "",
          childObjKey: "RelatedReport",
        },
        {
          alias: "Follow Up Actions",
          field: "FOLLOW_UP_NOTE",
          value: "",
          childObjKey: "RelatedReport",
        },
        {
          alias: "DH-Order (To Be Confirmed with Buildings Department)",
          field: "DHOrders",
          value: "",
          childObjKey: "RelatedReport",
          tableSpec: [
            {
              alias: "Case Ref.",
              field: "CASE_REF",
              value: [],
            },
            {
              alias: "Recommendation Date",
              field: "DATE_RECOM",
              value: [],
            },
            {
              alias: "DH Order",
              field: "ORDER_NO",
              value: [],
            },
            {
              alias: "Issue Date",
              field: "ISSUE_DATE",
              value: [],
            },
            {
              alias: "BD File Ref.",
              field: "BD_FILE",
              value: [],
            },
          ],
        },
        {
          alias: "Advisory Letter (To Be Confirmed with Buildings Department)",
          field: "AdvisoryLetters",
          value: "",
          childObjKey: "RelatedReport",
          tableSpec: [
            {
              alias: "Date of Recommandation to BD",
              field: "DATE_RECOM",
              value: [],
            },
            {
              alias: "File Reference",
              field: "BD_FILE",
              value: [],
            },
            {
              alias: "Date Served by BD",
              field: "DATE_ISSUE",
              value: [],
            },
          ],
        },
      ],
      EnhancedMaintInfo: [
        {
          alias: "",
          field: "EnhancedMaintenanceLastUpdate",
          value: "",
          childObjKey: "RelatedReport",
        },
        {
          alias: "Upgraded by:",
          field: "",
          value: "",
        },
        {
          alias: "Prescriptive Design Using GEO Report No. 56",
          field: "PRESCRIPT",
          value: [],
          childObjKey: "RelatedReport.EnhancedMaintenances",
        },
        {
          alias: "Non-prescriptive Design Including Conventional Design",
          field: "NPRESCRIPT",
          value: [],
          childObjKey: "RelatedReport.EnhancedMaintenances",
        },
        {
          alias: "Improved by:",
          field: "",
          value: "",
        },
        {
          alias: "Type 1 / Type 2 Prescriptive Measures",
          field: "TYPE1_2",
          value: [],
          childObjKey: "RelatedReport.EnhancedMaintenances",
        },
        {
          alias: "Type 3 Prescriptive Measures (not up to upgrading standard)",
          field: "TYPE3",
          value: [],
          childObjKey: "RelatedReport.EnhancedMaintenances",
        },
        {
          alias: "Non-Prescriptive Design including Conventional Design",
          field: "IMPROVED_NPRESCRIPT",
          value: [],
          childObjKey: "RelatedReport.EnhancedMaintenances",
        },
        {
          alias: "Actual Completion Date",
          field: "ACT_COMP",
          value: [],
          childObjKey: "RelatedReport.EnhancedMaintenances",
        },
      ],
      EnhancedMaintenances: [],
      EnhancedMaintenanceLastUpdate: "",
    };
  }
  componentDidMount() {
    console.log("Related Report Did Mount props", this.props);
    this.props.isShowTabCallback(true);
    let dataProcessClassObj = new dataProcessFunctions();
    let tmpBackgroundInfo = Object.assign([], this.state.BackgroundInfo);
    tmpBackgroundInfo = dataProcessClassObj.assignCellTableValues(
      tmpBackgroundInfo,
      this.props.attributes,
      ["RelatedReport", "RelatedReport.RaingaugeStation"]
    );
    let tmpEnhancedMaintInfo = Object.assign([], this.state.EnhancedMaintInfo);

    tmpEnhancedMaintInfo = dataProcessClassObj.assignCellTableValues(
      tmpEnhancedMaintInfo,
      this.props.attributes,
      ["RelatedReport", "RelatedReport.EnhancedMaintenances"]
    );

    let EnhancedMaintenanceLastUpdate = this.props.attributes.RelatedReport
      .EnhancedMaintenanceLastUpdate;
    let EnhancedMaintenances = addUpgradedByField(
      this.props.attributes.RelatedReport.EnhancedMaintenances
    );

    this.setState({
      BackgroundInfo: tmpBackgroundInfo,
      EnhancedMaintInfo: tmpEnhancedMaintInfo,
      EnhancedMaintenances: EnhancedMaintenances,
      EnhancedMaintenanceLastUpdate: EnhancedMaintenanceLastUpdate,
    });

    console.log("this.state.BackgroundInfo", this.state.BackgroundInfo);
    console.log("this.state.EnhancedMaintInfo", this.state.EnhancedMaintInfo);
  }

  render() {
    if (
      this.props.attributes?.RelatedReport?.EnhancedMaintenances.length === 0
    ) {
      return (
        <div>
          <div className="SubPanelTitle">Background Information</div>
          <CellTable data={this.state.BackgroundInfo} />
        </div>
      );
    } else {
      return (
        <div>
          <div className="SubPanelTitle">Background Information</div>
          <CellTable data={this.state.BackgroundInfo} />
          <div className="SubPanelTitle">ENHANCED MAINTENANCE INFORMATION</div>
          {/* <CellTable data={this.state.EnhancedMaintInfo} /> */}

          <div className="ResultInfoTable">
            <div className="EMI_header">
              {this.state.EnhancedMaintenanceLastUpdate}
            </div>
            {this.state.EnhancedMaintenances.map((item, index) => (
              <div key={index}>
                <div className="EMI_header">
                  Upgraded by : {item["Upgraded by"] || ""}
                </div>

                <div className="wRow">
                  <div className="rowCss">
                    <span>Prescriptive Design Using GEO Report No. 56</span>
                  </div>
                  <div className="ResultInfoRowValue">
                    <span>
                      {item["Prescriptive Design Using GEO Report No. 56"]}
                    </span>
                  </div>
                </div>

                <div className="wRow">
                  <div className="rowCss">
                    <span>
                      Non-prescriptive Design Including Conventional Design
                    </span>
                  </div>
                  <div className="ResultInfoRowValue">
                    <span>
                      {
                        item[
                          "Non-prescriptive Design Including Conventional Design"
                        ]
                      }
                    </span>
                  </div>
                </div>
                <div className="EMI_header">
                  Improved by : {item["Improved by"] || ""}
                </div>
                <div className="wRow">
                  <div className="rowCss">
                    <span>Type 1 / Type 2 Prescriptive Measures</span>
                  </div>
                  <div className="ResultInfoRowValue">
                    <span>{item["Type 1 / Type 2 Prescriptive Measures"]}</span>
                  </div>
                </div>
                <div className="wRow">
                  <div className="rowCss">
                    <span>
                      Type 3 Prescriptive Measures (not up to upgrading
                      standard)
                    </span>
                  </div>
                  <div className="ResultInfoRowValue">
                    <span>
                      {
                        item[
                          "Type 3 Prescriptive Measures (not up to upgrading standard)"
                        ]
                      }
                    </span>
                  </div>
                </div>
                <div className="wRow">
                  <div className="rowCss">
                    <span>
                      Non-Prescriptive Design including Conventional Design
                    </span>
                  </div>
                  <div className="ResultInfoRowValue">
                    <span>
                      {
                        item[
                          "Non-Prescriptive Design including Conventional Design"
                        ]
                      }
                    </span>
                  </div>
                </div>
                <div className="wRow">
                  <div className="rowCss">
                    <span>Actual Completion Date</span>
                  </div>
                  <div className="ResultInfoRowValue">
                    <span>{item["Actual Completion Date"]}</span>
                  </div>
                </div>
                <hr />
              </div>
            ))}
          </div>
        </div>
      );
    }
  }
}

export default DetailInfo;
